<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Degas Fee</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="degas" placeholder="Degas fee" :class="{ 'is-danger': errors.degas }">
                    <span class="icon is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                    <p v-if="errors.degas" class="help is-danger">{{ errors.degas[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            degas: {
                get() {
                    return this.$store.getters.getNewPricePlan.degas
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'degas', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/DegasInput.vue